import { Routes, Route } from "react-router-dom"
import { Outlet, Link } from "react-router-dom"
import Navbar from 'react-bootstrap/Navbar'
import Stack from "react-bootstrap/Stack"
import Button from "react-bootstrap/Button"
import classes from './Shitster.module.css'
import Container from "react-bootstrap/Container"
import ShitsterScanner from "./ShitsterScanner";
import ShitsterPlayer from "./ShitsterPlayer";
import {useEffect, useState, useRef} from "react";
import ShitsterGenerate from "./ShitsterGenerate";

function ShitsterHeader() {
  return (
    <Navbar className={'justify-content-center'}>
      <Navbar.Brand as={Link} to="/" ><span className={'small'}>💩</span> Shitster</Navbar.Brand>
    </Navbar>
  )
}

function ShitsterHome() {
  return (
    <Container>
      <Stack gap={3}>
        <Button className={classes.StackButton} as={Link} to="/scan" variant={'danger'}><span>📸</span> Scan Card</Button>
        <Button className={classes.StackButton} as={Link} to="/deck" variant={'primary'}><span>📝</span> Create Deck</Button>
      </Stack>
    </Container>
  )
}

function Shitster({token}) {

  const [paused, setPaused] = useState(false)
  const [player, setPlayer] = useState(undefined)
  const [deviceId, setDeviceId] = useState(undefined)
  const tokenRef = useRef(token)
  tokenRef.current = token

  useEffect(() => {
    const elementId = "spotiscript"

    // Create Spotify player only once
    if (!document.getElementById(elementId)) {
      // Callback for creating object
      window.onSpotifyWebPlaybackSDKReady = () => {

        const player = new window.Spotify.Player({
            name: 'Shitster',
            getOAuthToken: cb => { cb(tokenRef.current); },
            volume: 0.5
        });

        setPlayer(player);

        player.addListener('ready', ({ device_id }) => {
            console.log('Ready with Device ID');
            setDeviceId(device_id)
        });

        player.addListener('not_ready', ({ device_id }) => {
            console.log('Device ID has gone offline');
            setDeviceId(undefined)
        });

        player.addListener('player_state_changed', (data) => {
          if (!data) return
          setPaused(data.paused)
        });

        player.connect();
      };
      // Add Spotify script to DOM
      const script = document.createElement("script");
      script.src = "https://sdk.scdn.co/spotify-player.js";
      script.id = elementId
      document.body.appendChild(script);
    }

  }, []);

  return (
    <Routes>
      <Route path="/" element={
        <><ShitsterHeader/><Outlet /></>}>
        <Route index element={<ShitsterHome/>} />
        <Route path="scan" element={<ShitsterScanner/>} />
        <Route path="deck" element={<ShitsterGenerate token={token}/>} />
        <Route path="play/:songId" element={<ShitsterPlayer token={token} player={player} deviceId={deviceId} paused={paused}/>} />
        <Route path="*" element={<div className={'display-5'}>404 🫠</div>} />
      </Route>
    </Routes>
  )
}

export default Shitster
